import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {Dialog} from "@material-ui/core";
import ListDesigner from "./ListDesigner";
import PropTypes from "prop-types";

const styles = () => ({
    paperFullWidth: {
        height: '100%'
    }
});

const ListDesignerModal = (props) => {
    const {listId, onClose, setNewList, predefinedListValues, classes, history} = props;
    return (
        <Dialog
            open={true}
            onClose={onClose}
            fullWidth
            maxWidth={false}
            classes={{paperFullWidth: classes.paperFullWidth}}
        >
            <ListDesigner
                location={{state: {fieldValues: {id: listId}, fieldValuesId: listId}}}
                modal={true}
                predefinedListValues={predefinedListValues}
                setNewList={setNewList}
                history={history}
                onClose={onClose}
            />
        </Dialog>
    );
};

export default withStyles(styles)(ListDesignerModal)

ListDesignerModal.propTypes = {
    listId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    predefinedListValues: PropTypes.object,
    setNewList: PropTypes.func,
};